import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/public/training-institutions/training-client.tsx");
